import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import { getData } from "../../../CommonElements/Functions/PostGetFun";
import { API } from "../../../api/API";
import { dynamicImage } from "../../../Utils";
import { Image } from "../../../AbstractElements";

interface ReportingStructProps {
  employee_id: number;
}

const ReportingStruct: React.FC<ReportingStructProps> = ({ employee_id }) => {
  const [profileData, setProfileData] = useState<any[]>([]); // State to store API data
  const [loading, setLoading] = useState<boolean>(true); // State to manage loading
  const [error, setError] = useState<string | null>(null); // State to manage errors
  const serverUrl = localStorage.getItem("serverUrl");

  // Function to fetch profile data
  const fetchProfileData = async () => {
    try {
      if (!serverUrl) {
        setError("Server URL is not configured.");
        return;
      }

      setLoading(true);
      setError(null); // Reset error state
      const url = `${serverUrl}${API.getProfile}`;
      const { data, status } = await getData(url, true, { employee_id: employee_id }); // Call API with employee_id
      console.log("Profile Data:", data.data); // Print data to console
      if (status == 200 && data?.data) {
        setProfileData(data.data.Reporting || []); // Set data to state
      } else {
        setError("Failed to fetch profile data.");
      }
    } catch (error) {
      console.error("Error fetching profile data:", error);
      setError("An error occurred while fetching data.");
    } finally {
      setLoading(false);
    }
  };

  // useEffect to call fetchProfileData when employee_id changes
  useEffect(() => {
    if (employee_id) {
      fetchProfileData();
    }
  }, [employee_id]);

  return (
    <div className="px-2">
      {loading ? (
        <div className="text-center py-3">
          <div>
            <Image
              className="b-r-10 img-80"
              src={dynamicImage("dashboard/loader.gif")}
              alt="Loading..."
            />
          </div>
        </div>
      ) : error ? (
        <div className="text-center py-3 text-danger">{error}</div>
      ) : profileData.length > 0 ? (
        <div className="d-flex flex-column">
          {profileData.map((item, index) => (
            <Card
              key={item?.id || index} // Use unique identifier if available
              className="shadow-sm"
              style={{ marginLeft: `${index * 50}px` }} // 👈 shift like stairs
            >
              <CardHeader
                style={{ backgroundColor: "#007bff", padding: "7px" }}
                className="text-white d-flex align-items-center"
              >
                <img
                  src={dynamicImage("dashboard/profile.png") || "fallback-image.png"} // Static image with fallback
                  alt="Profile"
                  className="rounded-circle me-3"
                  style={{ width: "50px", height: "50px" }}
                />
                <div>
                  <h5 className="mb-0 text-white">
                    {`${item?.FirstName || "N/A"} ${item?.LastName || ""}`}
                  </h5>
                  <p className="mb-0 text-white" style={{ fontSize: "14px" }}>
                    {item?.Designations?.Designation || "No Designation"}
                  </p>
                </div>
              </CardHeader>
              <CardBody style={{ padding: "10px" }}>
                <p>
                  <strong>Email:</strong>{" "}
                  <a
                    href={`mailto:${item?.Email || ""}`}
                    className="text-primary"
                    style={{ textDecoration: "none" }}
                  >
                    {item?.Email || "N/A"}
                  </a>
                </p>
                <p>
                  <strong>Phone:</strong>{" "}
                  <a
                    href={`tel:${item?.Phone || ""}`}
                    className="text-primary"
                    style={{ textDecoration: "none" }}
                  >
                    {item?.Phone || "N/A"}
                  </a>
                </p>
              </CardBody>
            </Card>
          ))}
        </div>
      ) : (
        <p>No data available</p>
      )}
    </div>
  );
};

export default ReportingStruct;
